<template>
  <div>
    <div class="input-number-range">
      <div class="flex">
        <div class="from">
          <el-input
            ref="input_from"
            v-model="userInputForm"
            placeholder="min"
            @change="handleInputChangeFrom"
          ></el-input>
        </div>
        <div class="center">
          <span>~</span>
        </div>
        <div class="to">
          <el-input
            ref="input_to"
            v-model="userInputTo"
            placeholder="max"
            @change="handleInputChangeTo"
          ></el-input>
        </div>
      </div>
    </div>
  </div>
</template>
 
<script>
export default {
  name: 'InputNumberRange',
  props: {
    attrIndex:{
      required: true
    },
  },
  data() {
    return {
      userInputForm: null,
      userInputTo: null
    }
  },
  methods: {
    // 最小值change事件
    handleInputChangeFrom() {
      this.$emit('changeNumberStart',this.attrIndex,this.userInputForm)
    },
 
    // 最大change事件
    handleInputChangeTo() {
      this.$emit('changeNumberEnd',this.attrIndex,this.userInputTo)
    },
    // 清除最小值
    clearUserInputForm(){
      this.userInputForm = ""
    },
    //清除最大值 
    clearuserUserInputTo(){
      this.userInputTo = ""
    },
  }
}
</script>
<style lang="scss" scoped>
// 取消element原有的input框样式
::v-deep .el-input--mini .el-input__inner {
  border: 0px;
  margin: 0;
  padding: 0 15px;
  background-color: transparent;
}
.input-number-range {
  width: 200px;
  // background-color: #fff;
  // border: 1px solid #dcdfe6;
  border-radius: 4px;
}
.flex {
  // display: flex;
  // flex-direction: row;
  width: 100%;
  // justify-content: center;
  // align-items: center;
  .center {
    margin-top: 1px;
  }
 
  .from {
    display: inline-block;
    width: 40%;
 
    .el-input--mini .el-input__inner{
       width: 100% !important
    }
  }
 
  .center {
    display: inline-block;
    width: 20%;
    margin-top: 1px;
    text-align: center;
    font-size: 16px;
  }
 
  .to {
    display: inline-block;
    width: 40%;
 
    .el-input--mini .el-input__inner{
       width: 100% !important
    }
  }
  .el-input{
    font-size: 16px;
  }
}

.is-disabled {
  background-color: #eef0f6;
  border-color: #e4e7ed;
  color: #c0c4cc;
  cursor: not-allowed;
}
</style>